/**
 * Calendrier scolaire STATIQUE de La Réunion : repli quand l'API
 * data.education.gouv ne publie pas encore l'année en cours (l'outre-mer
 * arrive souvent après la métropole : constaté en août 2026, le dataset
 * avait 2026-2027 pour les zones A/B/C mais rien pour la Réunion).
 *
 * Source : calendrier officiel de l'académie de La Réunion, fourni par
 * l'utilisateur le 13/08/2026. À METTRE À JOUR chaque année tant que la
 * dépendance à l'API existe : le repli n'est servi QUE si l'année scolaire
 * courante correspond à ANNEE_CALENDRIER_STATIQUE (un calendrier périmé ne
 * doit jamais produire des dates fausses en silence, cf. vacances.js).
 */

export const ANNEE_CALENDRIER_STATIQUE = '2026-2027';

// Même forme que les vacances issues de l'API (événements background des
// calendriers). Hiver austral 2027 corrigé le 25/08/2026 sur le calendrier
// officiel publié : du 10 juillet au 17 août 2027 (rentrée 2027 estimée).
export const VACANCES_REUNION_STATIQUE = [
    { title: 'Rentrée des élèves', start: '2026-08-18', end: '2026-08-18', display: 'background', backgroundColor: '#b0b0b0', annee_scolaire: ANNEE_CALENDRIER_STATIQUE },
    { title: 'Vacances après 1re période', start: '2026-10-10', end: '2026-10-26', display: 'background', backgroundColor: '#b0b0b0', annee_scolaire: ANNEE_CALENDRIER_STATIQUE },
    { title: "Vacances de l'été austral", start: '2026-12-19', end: '2027-02-01', display: 'background', backgroundColor: '#b0b0b0', annee_scolaire: ANNEE_CALENDRIER_STATIQUE },
    { title: 'Vacances après 3e période', start: '2027-03-16', end: '2027-03-30', display: 'background', backgroundColor: '#b0b0b0', annee_scolaire: ANNEE_CALENDRIER_STATIQUE },
    { title: 'Vacances après 4e période', start: '2027-05-05', end: '2027-05-19', display: 'background', backgroundColor: '#b0b0b0', annee_scolaire: ANNEE_CALENDRIER_STATIQUE },
    { title: "Vacances de l'hiver austral", start: '2027-07-10', end: '2027-08-17', display: 'background', backgroundColor: '#b0b0b0', annee_scolaire: ANNEE_CALENDRIER_STATIQUE },
];

// Même forme que les périodes calculées par fetchSchoolHolidays :
// intervalle entre la fin d'une vacance et le début de la suivante
// (période 1 : de la rentrée aux premières vacances).
export const PERIODES_REUNION_STATIQUE = [
    { type_periode: 'Periode ', numero: 1, date_debut: '2026-08-18', date_fin: '2026-10-10' },
    { type_periode: 'Periode ', numero: 2, date_debut: '2026-10-26', date_fin: '2026-12-19' },
    { type_periode: 'Periode ', numero: 3, date_debut: '2027-02-01', date_fin: '2027-03-16' },
    { type_periode: 'Periode ', numero: 4, date_debut: '2027-03-30', date_fin: '2027-05-05' },
    { type_periode: 'Periode ', numero: 5, date_debut: '2027-05-19', date_fin: '2027-07-10' },
];
